



















































































































































































































































import { MStoreFormDatePicker, MStoreFormInput } from '@/components/shared';
import DynamicForm from '@/components/shared/DynamicForm.vue';
import MStoreColumnFilter from '@/components/shared/Table/MStoreColumnFilter.vue';
import { CabinetConstants, SchemaModel, SearchCriteriaModel, SearchPeriod, StoreConstants, ValueType } from '@/types';
import { ColumnFilterType } from '@/types/enums/ColumnFilterType';
import { ArrayUtils, EnumUtils } from '@/utils';
import moment from 'moment';
import Vue, { PropType } from 'vue';
import { Dictionary } from 'vue-router/types/router';
import ApiConfiguration from '@/classes/ApiConfiguration';
import { SearchReferenceValidationType, SearchCabinetModel, SearchReferenceModel, SearchDocumentTypeModel, FullTextSearchSettingType } from '@/services/GeneratedApi';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import LoadingOverlay from '@/components/shared/LoadingOverlay.vue';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  name: 'SearchBuilder',
  props: {
    searchCriteria: Object as PropType<SearchCriteriaModel>,
    isParentLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: true,
      cabinets: {} as Dictionary<Omit<SearchCabinetModel, 'id'>>,
      selectedCabinets: [],
      selectedDocumentTypes: [],
      chosenCabinets: [],
      chosenDocumentTypes: [],
      cabinetSelected: false,
      cabinetReferencesSchemas: [] as SchemaModel[],
      documentReferencesSchemas: [] as SchemaModel[],
      anyReferenceValue: '',
      includeDocumentContent: false,
      includeDateRange: false,
      searchPeriod: SearchPeriod.LastMonth,
      fromDate: moment()
        .add(-1, 'months')
        .toDate(),
      toDate: new Date(),
      isAdvancedSearch: false,
      advancedSearchOptions: [{ fieldKey: null, filterType: null, value: '' }] as Array<{ fieldKey: string | null; filterType: ColumnFilterType | null; value: string }>,
      orderBy: CabinetConstants.DocumentFields.DocumentDate,
      isSortingAscending: false,
      areCabinetReferencesLoading: false,
      areDocumentReferencesLoading: false,
      cabinetSelectFilter: '',
      documentTypeSelectFilter: '',
      fullTextParameter: FullTextSearchSettingType.VisibleNotChecked
    };
  },
  computed: {
    ...mapGetters('userPreferencesStore', [StoreConstants.UserPreferences.Getters.SearchOptions]),
    orderedCabinetsList(this: any): Array<{ id: string; description: string | null }> {
      return ArrayUtils.alphabeticalSort(
        Object.entries(this.cabinets as Dictionary<Omit<SearchCabinetModel, 'id'>>)
          .filter(([_, { description }]) => description?.contains(this.cabinetSelectFilter))
          .map(([id, { description }]: [string, Omit<SearchCabinetModel, 'id'>]) => ({ id, description })),
        (cabinet) => cabinet.description!.toLowerCase()
      );
    },
    orderedDocumentTypesList(this: any): SearchDocumentTypeModel[] {
      const documentTypes = (this.cabinets as Dictionary<Omit<SearchCabinetModel, 'id'>>)[this.chosenCabinets[0]].documentTypes!.filter((x) =>
        x.description?.contains(this.documentTypeSelectFilter)
      );
      return ArrayUtils.alphabeticalSort(documentTypes, (documentType) => documentType.description!.toLowerCase());
    },
    areAllCabinetsSelected(this: any): boolean {
      return this.selectedCabinets.length && this.selectedCabinets.length === Object.keys(this.cabinets).length;
    },
    selectedCabinetsText(this: any): string {
      return this.areAllCabinetsSelected ? 'All' : (this.selectedCabinets as string[]).map((id): string => this.cabinets[id].description as string).join(', ') || 'Please Select';
    },
    areAllDocumentTypesSelected(this: any): boolean {
      return this.selectedDocumentTypes.length && (this.availableDocumentTypeIds as number[]).every((selectedId) => this.selectedDocumentTypes.includes(selectedId));
    },
    selectedDocumentTypesText(this: any): string {
      if (this.areAllDocumentTypesSelected && !this.isSingleDocumentType) {
        return 'All';
      }
      const documentTypesForSelectedCabinets = (this.selectedCabinets as string[]).map((x) => this.cabinets[x] as SearchCabinetModel).flatMap((x) => x.documentTypes);
      return (
        [...(this.selectedDocumentTypes as Set<number>)]
          .map((selectedDocumentTypeId) => documentTypesForSelectedCabinets.find((documentType) => documentType!.id === selectedDocumentTypeId)?.description)
          .join(', ') || 'Please Select'
      );
    },
    isSingleCabinet(this: any): boolean {
      return this.chosenCabinets.length === 1;
    },
    isSingleDocumentType(this: any): boolean {
      return this.chosenDocumentTypes.length === 1;
    },
    availableDocumentTypeIds(this: any): number[] {
      return (this.chosenCabinets as string[]).flatMap((x) => (this.cabinets[x] as SearchCabinetModel).documentTypes).flatMap((documentType) => documentType!.id);
    },
    filterTypes(this: any): Array<{ description: string | undefined; key: number | null; disabled?: boolean }> {
      return [{ key: null, description: 'Please Select', disabled: true }, ...EnumUtils.getEnumValues(ColumnFilterType)];
    },
    advancedFilterFields(this: any) {
      const filterFields = [
        { value: CabinetConstants.DocumentFields.DocId, text: 'Document Id' },
        { value: CabinetConstants.DocumentFields.DocumentDate, text: 'Document Date' },
        { value: CabinetConstants.DocumentFields.BatchNumber, text: 'Batch Number' },
        { value: CabinetConstants.DocumentFields.FileType, text: 'File Type' },
        { value: CabinetConstants.DocumentFields.PageCount, text: 'Pages' },
        { value: CabinetConstants.DocumentFields.CreatedDate, text: 'Created Date' },
        { value: CabinetConstants.DocumentFields.Disk, text: 'Archive Disk' }
      ];
      if (this.isSingleCabinet) {
        const cabinetReferenceFields = (this.cabinetReferencesSchemas as SchemaModel[]).map(({ id, label }) => ({ value: id, text: label }));
        filterFields.push(...cabinetReferenceFields);
      }
      if (this.isSingleDocumentType) {
        const documentReferenceFields = (this.documentReferencesSchemas as SchemaModel[]).map(({ id, label }) => ({ value: id, text: label }));
        filterFields.push(...documentReferenceFields);
      }
      return filterFields;
    },
    orderByFields(this: any): Array<{ value: string }> {
      const referenceKeyRegex = this.isAdvancedSearch ? /^CB_/ : /^CB_(?:CREF|DREF|DOCDATE)/;
      return (this.advancedFilterFields as Array<{ value: string }>)?.filter(({ value }) => referenceKeyRegex.exec(value)?.length) ?? [];
    },
    cabinetsToggleClass(this: any) {
      const defaultClasses = ['custom-select', 'text-left', 'text-truncate'];
      const computedClasses = [];
      if (this.cabinetSelected && !this.chosenCabinets?.length) {
        computedClasses.push('is-invalid');
      }

      return [...defaultClasses, ...computedClasses];
    },
    documentTypesToggleClass(this: any) {
      const defaultClasses = ['custom-select', 'text-left', 'text-truncate'];
      const computedClasses = [];
      if (this.cabinetSelected && !this.chosenDocumentTypes?.length) {
        computedClasses.push('is-invalid');
      }

      return [...defaultClasses, ...computedClasses];
    },
    allFieldData(this: any) {
      const allSchemas: SchemaModel[] = [...this.cabinetReferencesSchemas, ...this.documentReferencesSchemas];
      return allSchemas.reduce((current, { fieldId, value }) => ({ ...current, [fieldId!]: value }), {});
    },
    fullTextEnabledOnSomeSelectedCabinets(this: any): boolean {
      if (!this.chosenCabinets || this.chosenCabinets.length === 0 || this.fullTextParameter === FullTextSearchSettingType.Hidden) {
        return false;
      }
      return this.chosenCabinets.some((cabinet: number) => cabinet && this.cabinets[cabinet].isFullTextSearchEnabled);
    },
    fullTextEnabledOnAllSelectedCabinets(this: any): boolean {
      if (!this.chosenCabinets || this.chosenCabinets.length === 0 || this.fullTextParameter === FullTextSearchSettingType.Hidden) {
        return false;
      }
      return this.chosenCabinets.every((cabinet: number) => cabinet && this.cabinets[cabinet].isFullTextSearchEnabled);
    },
    anyRefenceAndSearchInDocumentTitle(this: any) {
      return this.includeDocumentContent ? 'All References and Document Content' : 'All References';
    },
    anyRefenceAndSearchInDocumentPlaceholder(this: any) {
      return this.includeDocumentContent ? 'Search All References and Document Content' : 'Search All References';
    }
  },
  methods: {
    ...mapActions(StoreConstants.UserPreferences.ModuleName, [StoreConstants.UserPreferences.Actions.SetIncludeDocumentContent]),
    async initialiseSearch(this: any) {
      const searchCriteria: SearchCriteriaModel = { ...this.searchCriteria };

      if (!searchCriteria?.cabinets?.length) {
        return;
      }

      // Filter out cabinets the user no longer has access to
      searchCriteria.cabinets = searchCriteria.cabinets.filter((id: string) => this.cabinets.hasOwnProperty(id));

      this.cabinetSelected = true;
      this.selectedCabinets = [...searchCriteria.cabinets];
      this.chosenCabinets = [...searchCriteria.cabinets];

      // Get all available document type IDs for the selected cabinets
      const availableDocumentTypeIds = (this.chosenCabinets as string[]).flatMap((cabinetId) => this.cabinets[cabinetId]?.documentTypes ?? []).map((dt) => dt.id);
      // Filter out document types the user no longer has access to
      searchCriteria.documentTypes = (searchCriteria.documentTypes ?? []).filter((id: number) => availableDocumentTypeIds.includes(id));

      this.selectedDocumentTypes = [...searchCriteria.documentTypes];
      this.chosenDocumentTypes = [...searchCriteria.documentTypes];

      if (searchCriteria.orderBy) {
        this.orderBy = searchCriteria.orderBy.field;
        this.isSortingAscending = searchCriteria.orderBy.isSortingAscending;
      }

      if (searchCriteria.dateRange) {
        this.includeDateRange = true;
        if (searchCriteria.dateRange.searchPeriod === SearchPeriod.Custom) {
          this.searchPeriod = SearchPeriod.Custom;
          this.fromDate = searchCriteria.dateRange.from;
          this.toDate = searchCriteria.dateRange.to;
        } else {
          this.onSelectSearchPeriod(searchCriteria.dateRange.searchPeriod);
        }
      } else {
        this.includeDateRange = false;
        this.searchPeriod = SearchPeriod.LastMonth;
        this.fromDate = moment()
          .add(-1, 'months')
          .toDate();
        this.toDate = new Date();
      }

      if (searchCriteria.isAdvancedSearch) {
        this.isAdvancedSearch = true;
        await Promise.all([this.getCabinetReferences(), this.getDocumentReferences()]);
        const advancedSearchOptions = [...searchCriteria.advancedSearch!];
        if (searchCriteria.anyReference?.value) {
          advancedSearchOptions?.splice(0, 0, { fieldKey: this.ALL_REFERENCES_KEY, value: searchCriteria.anyReference.value, filterType: searchCriteria.anyReference.filterType });
        }
        if (searchCriteria.isFullTextSearch) {
          advancedSearchOptions?.splice(0, 0, { fieldKey: this.DOCUMENT_CONTENT_KEY, value: searchCriteria.fullTextSearchValue ?? '', filterType: ColumnFilterType.Contains });
        }
        this.advancedSearchOptions = advancedSearchOptions;
      } else {
        this.anyReferenceValue = searchCriteria.anyReference?.value ?? '';
        this.includeDocumentContent = this[StoreConstants.UserPreferences.Getters.SearchOptions].includeDocumentContent ?? this.fullTextParameter === FullTextSearchSettingType.VisibleAndChecked;
        const referenceValues = searchCriteria.standardSearch ? [...searchCriteria.standardSearch].reduce((values, { fieldKey, value }) => ({ ...values, [fieldKey]: value }), {}) : [];
        await Promise.all([this.getCabinetReferences(referenceValues), this.getDocumentReferences(referenceValues)]);
      }
    },
    toggleSelectAllCabinets(this: any) {
      this.selectedCabinets = this.areAllCabinetsSelected ? [] : [...Object.keys(this.cabinets)];
    },
    toggleSelectAllDocumentTypes(this: any) {
      this.selectedDocumentTypes = this.areAllDocumentTypesSelected ? [] : [...this.availableDocumentTypeIds];
    },
    areAllDocumentTypesSelectedForCabinet(this: any, cabinetId: string): boolean {
      const documentTypeIds = (this.cabinets[cabinetId] as SearchCabinetModel).documentTypes!.map(({ id }) => id);
      return documentTypeIds.every((id) => this.selectedDocumentTypes.includes(id));
    },
    onCabinetDropdownShown(this: any) {
      this.$refs.cabinetSelectFilterInput.focus();
    },
    async onCabinetDropdownHidden(this: any) {
      if (this.selectedCabinets.length) {
        this.cabinetSelected = true;
      }
      if (this.selectedCabinets.length === this.chosenCabinets.length && this.selectedCabinets.every((x: string) => this.chosenCabinets.includes(x))) {
        return;
      }
      if (
        (this.orderBy as string).startsWith(CabinetConstants.DocumentFields.CabinetReferencePrefix) ||
        (this.orderBy as string).startsWith(CabinetConstants.DocumentFields.DocumentReferencePrefix)
      ) {
        this.orderBy = CabinetConstants.DocumentFields.DocumentDate;
      }

      this.chosenCabinets = [...this.selectedCabinets];
      this.selectedDocumentTypes = [];
      this.chosenDocumentTypes = [];

      this.advancedSearchOptions = (this.advancedSearchOptions as Array<{ fieldKey: string | null; filterType: ColumnFilterType | null; value: string }>).map((x) => ({
        ...x,
        fieldKey:
          x.fieldKey?.startsWith(CabinetConstants.DocumentFields.CabinetReferencePrefix) ||
          x.fieldKey?.startsWith(CabinetConstants.DocumentFields.DocumentReferencePrefix) ||
          (x.fieldKey === this.DOCUMENT_CONTENT_KEY && !this.fullTextEnabledOnSelectedCabinets)
            ? null
            : x.fieldKey
      }));

      if (!this.fullTextEnabledOnAllSelectedCabinets) {
        this.includeDocumentContent = false;
        this[StoreConstants.UserPreferences.Actions.SetIncludeDocumentContent](false);
      } else if (!this.isAdvancedSearch) {
        this.includeDocumentContent = this[StoreConstants.UserPreferences.Getters.SearchOptions].includeDocumentContent ?? this.fullTextParameter === FullTextSearchSettingType.VisibleAndChecked;
      }

      if (this.chosenCabinets.length === 1) {
        this.selectedDocumentTypes = [...this.availableDocumentTypeIds];
        this.chosenDocumentTypes = [...this.availableDocumentTypeIds];
      }
      this.documentReferencesSchemas = [];

      await Promise.all([this.getCabinetReferences(), this.getDocumentReferences()]);

      if (this.areAllCabinetsSelected && !this.isAdvancedSearch) {
        this.$refs.anyReferenceInput.focus();
      }
    },
    async getCabinetReferences(this: any, values?: { [key: string]: string }) {
      if (this.isSingleCabinet) {
        this.areCabinetReferencesLoading = true;
        try {
          this.cabinetReferencesSchemas = (await ApiConfiguration.api().search.searchCabinetReferencesDetail(this.selectedCabinets[0])).map((x) => this.MAP_TO_SCHEMA(x, values));
        } finally {
          this.areCabinetReferencesLoading = false;
        }
      } else {
        this.cabinetReferencesSchemas = [];
      }
    },
    onDocumentTypeDropdownShown(this: any) {
      this.$refs.documentTypeSelectFilterInput.focus();
    },
    async onDocumentTypeDropdownHidden(this: any) {
      if (this.selectedDocumentTypes.length === this.chosenDocumentTypes.length && this.selectedDocumentTypes.every((x: number) => this.chosenDocumentTypes.includes(x))) {
        return;
      }
      if ((this.orderBy as string).startsWith(CabinetConstants.DocumentFields.DocumentReferencePrefix)) {
        this.orderBy = CabinetConstants.DocumentFields.DocumentDate;
      }

      this.advancedSearchOptions = (this.advancedSearchOptions as Array<{ fieldKey: string | null; filterType: ColumnFilterType | null; value: string }>).map((x) => ({
        ...x,
        fieldKey: x.fieldKey?.startsWith(CabinetConstants.DocumentFields.DocumentReferencePrefix) ? null : x.fieldKey
      }));

      this.chosenDocumentTypes = [...this.selectedDocumentTypes];

      await this.getDocumentReferences();
    },
    async getDocumentReferences(this: any, values?: { [key: string]: string }) {
      if (this.isSingleDocumentType) {
        this.areDocumentReferencesLoading = true;
        try {
          this.documentReferencesSchemas = (await ApiConfiguration.api().search.searchDocumentReferencesDetail(this.selectedCabinets[0], this.selectedDocumentTypes[0])).map((x) =>
            this.MAP_TO_SCHEMA(x, values)
          );
        } finally {
          this.areDocumentReferencesLoading = false;
        }
      } else {
        this.documentReferencesSchemas = [];
      }
    },
    onSelectSearchPeriod(searchPeriod: SearchPeriod) {
      this.searchPeriod = searchPeriod;

      switch (searchPeriod) {
        case SearchPeriod.LastMonth:
          this.fromDate = moment()
            .add(-1, 'months')
            .toDate();
          this.toDate = new Date();
          break;
        case SearchPeriod.LastThreeMonths:
          this.fromDate = moment()
            .add(-3, 'months')
            .toDate();
          this.toDate = new Date();
          break;
        case SearchPeriod.LastYear:
          this.fromDate = moment()
            .add(-1, 'years')
            .toDate();
          this.toDate = new Date();
          break;
      }
    },
    updateDate(this: any, field: string, newValue: string) {
      const newDate = newValue ? new Date(newValue) : null;
      this[field] = newDate;
    },
    addAdvancedSearchOption(this: any) {
      if (this.advancedSearchOptions.length < 20) {
        this.advancedSearchOptions = [...this.advancedSearchOptions, { fieldKey: null, filterType: null, value: '' }];
      }
    },
    async search(this: any) {
      const isValid = !this.isAdvancedSearch || (await this.$refs.advancedSearchValidationObserver.validate());
      if (!isValid) {
        return;
      }

      const advancedSearchCriteria: Array<{ fieldKey: string | null; filterType: ColumnFilterType | null; value: string }> = [...this.advancedSearchOptions];
      let anyReference: { value: string; filterType: ColumnFilterType | null; includeFullText: boolean } | null = null;
      let fullTextSearchValue = null;
      let isFullTextSearch = false;
      if (this.isAdvancedSearch) {
        const advancedSearchAnyReferenceCriterionIndex = advancedSearchCriteria.findIndex((x) => x.fieldKey === this.ALL_REFERENCES_KEY);
        if (advancedSearchAnyReferenceCriterionIndex >= 0) {
          const advancedSearchAnyReferenceCriterion = advancedSearchCriteria.splice(advancedSearchAnyReferenceCriterionIndex, 1)[0];
          anyReference = { value: advancedSearchAnyReferenceCriterion.value, filterType: advancedSearchAnyReferenceCriterion.filterType, includeFullText: false };
        }

        const advancedSearchFullTextCriterionIndex = advancedSearchCriteria.findIndex((x) => x.fieldKey === this.DOCUMENT_CONTENT_KEY);
        if (advancedSearchFullTextCriterionIndex >= 0) {
          const advancedSearchFullTextCriterion = advancedSearchCriteria.splice(advancedSearchFullTextCriterionIndex, 1)[0];
          fullTextSearchValue = advancedSearchFullTextCriterion.value;
          isFullTextSearch = true;
        }
      } else {
        anyReference = {
          value: this.anyReferenceValue,
          filterType: null,
          includeFullText: this.includeDocumentContent
        };
      }

      const searchCriteria: SearchCriteriaModel = {
        cabinets: [...this.chosenCabinets],
        documentTypes: [...this.chosenDocumentTypes],
        anyReference,
        orderBy: {
          field: this.orderBy,
          isSortingAscending: this.isSortingAscending
        },
        dateRange: this.includeDateRange
          ? {
              searchPeriod: this.searchPeriod,
              from: this.searchPeriod === SearchPeriod.Custom ? this.fromDate : null,
              to: this.searchPeriod === SearchPeriod.Custom ? this.toDate : null
            }
          : null,
        standardSearch: this.isAdvancedSearch
          ? null
          : ([...this.cabinetReferencesSchemas, ...this.documentReferencesSchemas] as SchemaModel[]).filter(({ value }) => value).map(({ id, value }) => ({ fieldKey: id, value })),
        isAdvancedSearch: this.isAdvancedSearch,
        advancedSearch: this.isAdvancedSearch ? advancedSearchCriteria : null,
        isFullTextSearch,
        fullTextSearchValue
      };

      this.$emit('search', searchCriteria);
    },
    clearSearch(this: any) {
      this.advancedSearchOptions = (this.advancedSearchOptions as Array<{ fieldKey: string | null; filterType: ColumnFilterType | null; value: string }>).map((x) => ({ ...x, value: '' }));
      this.anyReferenceValue = '';
      this.cabinetReferencesSchemas = (this.cabinetReferencesSchemas as SchemaModel[]).map((x) => ({ ...x, value: '' }));
      this.documentReferencesSchemas = (this.documentReferencesSchemas as SchemaModel[]).map((x) => ({ ...x, value: '' }));
    },
    resetSearch(this: any) {
      this.cabinetSelected = false;
      this.selectedCabinets = [];
      this.selectedDocumentTypes = [];
      (this.chosenCabinets = []), (this.chosenDocumentTypes = []), (this.cabinetReferencesSchemas = []);
      this.documentReferencesSchemas = [];
      this.isAdvancedSearch = false;
      this.advancedSearchOptions = [{ fieldKey: null, filterType: null, value: '' }];
      this.orderBy = CabinetConstants.DocumentFields.DocumentDate;
      this.isSortingAscending = false;
      this.includeDocumentContent = false;
      this.includeDateRange = false;
      this.searchPeriod = SearchPeriod.LastMonth;
      this.fromDate = moment()
        .add(-1, 'months')
        .toDate();
      this.toDate = new Date();
      this.cabinetSelectFilter = '';
      this.documentTypeSelectFilter = '';
    },
    preventDisallowedCharacters(this: any, event: KeyboardEvent, fieldKey: string) {
      if (this.NUMBER_TYPE_FIELDS.includes(fieldKey) && !/^[0-9]$/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChangeAdvancedSearchField(this: any, updatedValue: string, advancedSearchOption: { fieldKey: string | null; filterType: ColumnFilterType | null; value: string }) {
      if (this.VALUE_TYPE_FIELDS.includes(updatedValue) && !this.VALUE_FILTER_TYPES.find(({ key }: { key: number }) => key === advancedSearchOption.filterType)) {
        advancedSearchOption.filterType = null;
      }
      advancedSearchOption.value = '';
    },
    setIncludeDocumentContentValue(this: any, value: boolean) {
      this.includeDocumentContent = value;
      this[StoreConstants.UserPreferences.Actions.SetIncludeDocumentContent](value);
    },
    getFilterTypes(this: any, fieldKey: string) {
      if (this.VALUE_TYPE_FIELDS.includes(fieldKey)) {
        return this.VALUE_FILTER_TYPES;
      } else if (this.FULL_TEXT_TYPE_FIELDS.includes(fieldKey)) {
        return this.FULL_TEXT_FILTER_TYPES;
      } else {
        return this.ALL_FILTER_TYPES;
      }
    }
  },
  async mounted(this: any) {
    try {
      const searchBuilderModel = await ApiConfiguration.api().search.searchSearchBuilderList();
      const cabinetsList = searchBuilderModel.cabinets;
      this.fullTextParameter = searchBuilderModel.fullTextSearchSetting;
      this.cabinets = cabinetsList?.reduce((cabinets, cabinet) => ({ ...cabinets, [cabinet.id!]: { ...cabinet } }), {} as Dictionary<Omit<SearchCabinetModel, 'id'>>);
      await this.initialiseSearch();
    } finally {
      this.isLoading = false;
    }
  },
  created(this: any) {
    this.SEARCH_PERIODS = Object.values(SearchPeriod);

    this.GET_VALUE_TYPE = ((searchReferenceValidationType: SearchReferenceValidationType) => {
      switch (searchReferenceValidationType) {
        case SearchReferenceValidationType.Alphanumeric:
          return ValueType.AlphaNumeric;
        case SearchReferenceValidationType.Numeric:
          return ValueType.Integer;
        default:
          return ValueType.Any;
      }
    }) as (searchReferenceValidationType: SearchReferenceValidationType) => ValueType;

    this.MAP_TO_SCHEMA = (({ fieldKey, description, validationType, uppercase, listId, fieldId }: SearchReferenceModel, values?: { [key: string]: string }) =>
      ({
        id: fieldKey,
        label: description ?? '',
        componentProperties: {
          componentName: listId ? 'MStoreFormLookup' : validationType === SearchReferenceValidationType.Date ? 'MStoreFormDatePicker' : 'MStoreFormInput',
          forceUpperCase: uppercase,
          listId,
          hasInitialList: false,
          formId: '',
          allowTypedValue: true,
          valueType: validationType === SearchReferenceValidationType.Date ? 'format' : undefined
        },
        value: values && values[fieldKey!] ? values[fieldKey!] : '',
        validation: { valueType: this.GET_VALUE_TYPE(validationType) },
        fieldId
      } as SchemaModel)) as (searchReferenceModel: SearchReferenceModel, values?: { [key: string]: string }) => SchemaModel;

    this.ALL_REFERENCES_KEY = 'AnyReference';
    this.DOCUMENT_CONTENT_KEY = 'DocumentContent';
    const allFilterTypes = EnumUtils.getEnumValues(ColumnFilterType);
    const valueFilterTypes = allFilterTypes.filter(({ key }) =>
      [
        ColumnFilterType.Equals,
        ColumnFilterType.DoesNotEqual,
        ColumnFilterType.LessThan,
        ColumnFilterType.LessThanOrEqualTo,
        ColumnFilterType.GreaterThan,
        ColumnFilterType.GreaterThanOrEqualTo
      ].includes(key)
    );
    const fullTextFilterTypes = allFilterTypes.filter(({ key }) => [ColumnFilterType.Contains].includes(key));
    const defaultFilterType = { key: null, description: 'Please Select', disabled: true };
    this.ALL_FILTER_TYPES = [{ ...defaultFilterType }, ...allFilterTypes];
    this.VALUE_FILTER_TYPES = [{ ...defaultFilterType }, ...valueFilterTypes];
    this.FULL_TEXT_FILTER_TYPES = [{ ...defaultFilterType }, ...fullTextFilterTypes];
    this.VALUE_TYPE_FIELDS = [
      CabinetConstants.DocumentFields.DocId,
      CabinetConstants.DocumentFields.DocumentDate,
      CabinetConstants.DocumentFields.CreatedDate,
      CabinetConstants.DocumentFields.PageCount,
      CabinetConstants.DocumentFields.BatchNumber
    ];
    this.FULL_TEXT_TYPE_FIELDS = ['DocumentContent'];

    this.NUMBER_TYPE_FIELDS = [CabinetConstants.DocumentFields.DocId, CabinetConstants.DocumentFields.PageCount, CabinetConstants.DocumentFields.BatchNumber];
    this.DATE_TYPE_FIELDS = [CabinetConstants.DocumentFields.DocumentDate, CabinetConstants.DocumentFields.CreatedDate];
  },
  components: {
    DynamicForm,
    MStoreFormInput,
    MStoreFormDatePicker,
    MStoreColumnFilter,
    LoadingSpinner,
    LoadingOverlay
  },
  watch: {
    searchCriteria(this: any) {
      if (!this.isLoading) {
        this.initialiseSearch();
      }
    }
  }
});
